// Branch
import getBranch from '../../branch/lib/getBranch.lib.branch';

// Gas
import sections from '@drivesally/sally-fn/lib/gas/sections/sections';

export const sectionsObject = ({vehicle = {}, gas = {}} = {}) =>
  [...sectionsList({vehicle, gas})].reduce(
    (combined, current) => ({...combined, [current.key]: {...current}}),
    {}
  );

export const sectionsList = ({vehicle = {}, gas = {}} = {}) => {
  // Callers pass null before a gas/vehicle has loaded. Defaults only replace
  // undefined, so normalize here or `gas.type` throws on first render.
  const safeVehicle = vehicle || {};
  const safeGas = gas || {};
  const branch = getBranch(safeVehicle.sally_branch);
  const branchTypeSections = branch?.gas_config?.[safeGas.type];
  const branchSections = !!branchTypeSections
    ? Array.isArray(branchTypeSections)
      ? branchTypeSections
      : [branchTypeSections]
    : [];
  const branchSectionKeys = branchSections.map((entry) =>
    typeof entry === 'object' && entry !== null ? entry.key : entry
  );
  // Onsite gas objects no longer get manually checked out - see the matching
  // exclusion in sally-gas's sections.lib.vehicle.js.
  const hiddenKeys =
    safeGas.type === 'onsite' || safeGas.type === 'onsite_sitting'
      ? ['checkout']
      : [];
  return [...sections]
    .filter(
      (section) =>
        !hiddenKeys.includes(section.key) &&
        branchSectionKeys.includes(section.key)
    )
    .map((section) => {
      const status = safeGas.completion_status?.sections?.[section.key] || {
        status: 'pending',
        progress: 0,
        message: section.label,
      };
      return {
        ...section,
        status,
      };
    });
};
